// @flow
import { unauthenticatedFetch } from '../../api/request';

const getMinorInformation = async (emailCommunicationKey: string) => {
    return await unauthenticatedFetch(`/public/v5/parentGuardianConsent/${emailCommunicationKey}/user`);
};

export default getMinorInformation;
